module.exports = __webpack_public_path__ + "b6d71af3d70c73e3cef5289093b88943.svg";